var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21L22 25L31 16M40 42V15.6C40 12.2397 40 10.5595 39.346 9.27606C38.7708 8.14708 37.8529 7.2292 36.7239 6.65396C35.4405 6 33.7603 6 30.4 6H17.6C14.2397 6 12.5595 6 11.2761 6.65396C10.1471 7.2292 9.2292 8.14708 8.65396 9.27606C8 10.5595 8 12.2397 8 15.6V42L13.5 38L18.5 42L24 38L29.5 42L34.5 38L40 42Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptCheck);
export default __webpack_public_path__ + "static/media/receipt-check.662b6a7b08fb993e7cc539c9105ba3f9.svg";
export { ForwardRef as ReactComponent };